import { writeHtmlAndMarkdownToClipboard } from '@/helpers/copyHelpers/copyHelpers-v2';
import { useState } from 'react';

export const useCopyToClipboard = (timeout = 2200) => {
  const [isCopied, setIsCopied] = useState(false);

  const copyToClipboard = async (text: string): Promise<boolean> => {
    try {
      await writeHtmlAndMarkdownToClipboard({ markdown: text });
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), timeout);
      return true;
    } catch {
      return false;
    }
  };

  return {
    isCopied,
    copyToClipboard,
  };
};
